import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Mobile20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path d='M12.5 5.75H7.5V4.25H12.5V5.75Z' fill='currentColor' />
    <path
      d='M11 15C11 15.5523 10.5523 16 10 16C9.44772 16 9 15.5523 9 15C9 14.4477 9.44772 14 10 14C10.5523 14 11 14.4477 11 15Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.25 1.5625C3.25 0.792765 3.90075 0.25 4.6 0.25H15.4C16.0993 0.25 16.75 0.792765 16.75 1.5625V18.4375C16.75 19.2072 16.0993 19.75 15.4 19.75H4.6C3.90075 19.75 3.25 19.2072 3.25 18.4375V1.5625ZM4.75 1.75V18.25H15.25V1.75H4.75Z'
      fill='currentColor'
    />
  </Svg>
);

Mobile20.displayName = 'Mobile20';
export default Mobile20;
